import React, { Component, Suspense } from 'react'
import PropTypes from 'prop-types'
import Overlay, { StopPropagation } from '@ynap/overlay'
import Lite from '@ynap/product-details-page/src/Layouts/Lite'
import { Portal } from 'react-portal'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('LineItemEditOverlay')
const QuickViewLayout = React.lazy(() => import(/* webpackChunkName: "QuickViewLayout" */ '@ynap/product-details-page/src/Layouts/QuickView'))

class LineItemEditOverlay extends Component {
    static propTypes = {
        fetchProductDetails: PropTypes.func.isRequired,
        updateMiniPdpLineItem: PropTypes.func.isRequired,
        setSelectedVariant: PropTypes.func.isRequired,
        toggleproductOverlay: PropTypes.func.isRequired,
        addToBagWithCartSync: PropTypes.func.isRequired,
        cartLineItem: {
            isReservation: PropTypes.bool,
        },
        addToBagState: {
            loading: PropTypes.bool,
        },
        partNumber: PropTypes.string.isRequired,
        partOfBasket: PropTypes.bool,
    }

    componentDidMount() {
        const { partNumber, isRecommendation } = this.props

        if (partNumber) {
            this.props.fetchProductDetails(partNumber, isRecommendation)
        }
    }

    render() {
        const {
            updateMiniPdpLineItem,
            setSelectedVariant,
            partNumber,
            locale,
            cartLineItem,
            toggleproductOverlay,
            partOfBasket,
            addToBagWithCartSync,
            messages,
            addToBagState,
            addItemsToWishlistError,
            isRecommendation,
            country,
            consideredBadge,
            ...rest
        } = this.props

        if (partNumber && partNumber.length) {
            const closeOverlay = () => toggleproductOverlay()
            const closeOverlayAfterDelay = () =>
                setTimeout(() => {
                    toggleproductOverlay()
                }, 2000)

            const addToBag = async (newPartNumber, params) => {
                const { quantity } = params
                const similarPartNumber = this.props?.lineItems.filter((item) => item.partNumber === newPartNumber)[0]
                const isMaxQty = similarPartNumber && similarPartNumber.quantity > similarPartNumber.designerCartItemLimit

                if (isMaxQty) {
                    return await {
                        toggleRectificationMsg: isMaxQty,
                    }
                } else if (partOfBasket && !isMaxQty) {
                    return updateMiniPdpLineItem(partNumber, quantity, newPartNumber, closeOverlay)
                } else if (!partOfBasket) {
                    return addToBagWithCartSync(
                        newPartNumber,
                        { ...params, includeShoppingCart: true },
                        {
                            handleSuccess: isRecommendation ? closeOverlayAfterDelay : undefined,
                        }
                    )
                }
            }
            const newMessages = partOfBasket ? messages : { ...messages, ctaButtons: { ...messages.ctaButtons, addToBag: messages.ctaButtons.add } }
            const type = isRecommendation ? 'recommendation' : 'pdp'

            return (
                <Portal>
                    <Overlay onClose={closeOverlay} handleBodyClick={closeOverlay} type={type} className={bem(type)}>
                        <StopPropagation>
                            <Suspense fallback={<Lite loading={true} {...this.props} />}>
                                <QuickViewLayout
                                    {...rest}
                                    selectProduct={({ partNumber }) => setSelectedVariant(partNumber)}
                                    addToCart={addToBag}
                                    addToCartLoading={addToBagState.loading}
                                    addToWishlist={null}
                                    disabledControls={cartLineItem?.isReservation}
                                    locale={locale}
                                    messages={newMessages}
                                    errors={{
                                        addToWishlist: addItemsToWishlistError,
                                        addToCart: addToBagState.error,
                                    }}
                                    cartLineItem={cartLineItem}
                                    isRecommendation={isRecommendation}
                                    country={country}
                                    isShoppingBag={true}
                                    consideredBadge={consideredBadge}
                                />
                            </Suspense>
                        </StopPropagation>
                    </Overlay>
                </Portal>
            )
        }

        return null
    }
}

export default LineItemEditOverlay
